import Request from '../util/request';

const path = "/eip-mapp-oa-server/task"
// const path = "http://10.10.5.74:8647/task"

const syncPath = "/eip-mapp-oa-server"
const deletePath = "/eip-mapp-es-server"

// 我处理的
export function getMyHandled(data) {
  return Request({
    url: path + '/myHandled',
    method: 'post',
    data
  })
}

// 我的待办
export function getMyHandling(data) {
  return Request({
    url: path + '/myHandling',
    method: 'post',
    data
  })
}

// 我发起的
export function getMyStart(data) {
  return Request({
    url: path + '/myStart',
    method: 'post',
    data
  })
}

// 抄送我的
export function getMySend(data) {
  return Request({
    url: path + '/mySend',
    method: 'post',
    data
  })
}

// 获取预警状态
export function queryAlertStatus(data) {
  return Request({
    url: path + '/queryAlertStatus',
    method: 'post',
    data
  })
}

export function getStartStatus(data) {
  return Request({
    url: path + '/getStartStatus',
    method: 'post',
    data
  })
}

export function syncData(data) {
  return Request({
    url: syncPath + '/synchronousElasticSearch?serverName=' + data,
    method: 'get',
    data
  })
}

export function deteleData(params) {
  return Request({
    url: deletePath,
    method: 'delete',
    params
  })
}

export function getAnalyze(data) {
  return Request({
    url: path + '/analyze',
    method: 'post',
    headers: { "Content-Type": "text/plain" },
    data
  })
}

export function getMyhandedCount(data) {
  return Request({
    url: path + '/myhandedCount',
    method: 'post',
    data
  })
}

export function typeCountByEs(data) {
  return Request({
    url: path + '/typeCountByEs',
    method: 'post',
    data
  })
}

export function typeCount(data) {
  return Request({
    url: path + '/typeCount',
    method: 'post',
    data
  })
}

export function getMystartCount(data) {
  return Request({
    url: path + '/mystartCount',
    method: 'post',
    data
  })
}

// 流程编号获取流程
export function queryFlow(data) {
  return Request({
    url: syncPath + '/common/queryFlow',
    method: 'post',
    data
  })
}
/**
 * 加签
 */
 export const addMinusSign = data => {
  return Request({
    url: path + '/addMinusSign',
    headers: {
      procInstId: data.procId
    },
    method: 'post',
    data
  })
}

/**
 * 前加签
 * @param data
 */
export const addSignbefore = data => {
  return Request({
    url: path + '/addSignbefore',
    headers: {
      procInstId: data.processId
    },
    method: 'post',
    data
  })
}

/**
 * 后加签
 * @param data
 */
export const addSignAfter = data => {
  return Request({
    url: path + '/addSignAfter',
    headers: {
      procInstId: data.processId
    },
    method: 'post',
    data
  })
}


/**
 * 转交
 */
export function changeTaskUser(data, procInstId) {
  return Request({
    url: path + '/changeTaskUser',
    headers: procInstId,
    method: 'post',
    data
  })
}